import { render, staticRenderFns } from "./OntologyDetails.vue?vue&type=template&id=e68b0e42&"
import script from "./OntologyDetails.vue?vue&type=script&lang=js&"
export * from "./OntologyDetails.vue?vue&type=script&lang=js&"
import style0 from "./OntologyDetails.vue?vue&type=style&index=0&id=e68b0e42&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports